import { render, staticRenderFns } from "./SharkMan.vue?vue&type=template&id=2aec57b8&scoped=true"
import script from "./SharkMan.vue?vue&type=script&lang=js"
export * from "./SharkMan.vue?vue&type=script&lang=js"
import style0 from "./SharkMan.vue?vue&type=style&index=0&id=2aec57b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aec57b8",
  null
  
)

export default component.exports